export default __webpack_public_path__ + "static/preview-cd2d72b714a8f9a82e31ff1eecbd64e8.jpg";